import type { Component } from 'solid-js';
import { onCleanup, onMount } from 'solid-js';
import { useNavigate } from '@solidjs/router';

declare global {
    interface Window {
        __cleptaSearch?: (q: string, year: string | null) => void;
    }
}

/**
 * Bridge between the Twig-rendered header search input (lives outside the
 * Solid tree) and Solid Router. Updating window.location via history alone
 * doesn't reactively update Solid's location signal in all cases, so we
 * expose a bound `useNavigate()` for the inline header script to call.
 */
export const SearchBridge: Component = () => {
    const navigate = useNavigate();

    onMount(() => {
        window.__cleptaSearch = (q, year) => {
            const path = year ? `/${year}` : '/';
            const target = q ? `${path}?q=${encodeURIComponent(q)}` : path;
            navigate(target, { replace: true, scroll: false });
        };
    });

    onCleanup(() => {
        delete window.__cleptaSearch;
    });

    return null;
};
